import React, { useCallback, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch } from '~/hooks'

import { actions as authActions } from '~/redux/auth'
import { actions as userActions } from '~/redux/user'
import { actions as dataWorkdaysActions } from '~/redux/workdays/data'

const Login: React.FC = () => {
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')

	// Dispatch
	const dispatch = useDispatch()

	const handleLogin: React.FormEventHandler<HTMLFormElement> = useCallback(
		e => {
			e.preventDefault()
			dispatch(authActions.login({ email, password })).then(() => {
				dispatch(dataWorkdaysActions.init())
				dispatch(userActions.userAsync())
			})
		},
		[dispatch, email, password]
	)

	useEffect(() => {
		dispatch(dataWorkdaysActions.reset())
	}, [dispatch])

	return (
		<div className="h-full flex flex-col justify-center">
			<div className="container mx-auto md:max-w-3xl p-4">
				<div className="shadow-md bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-100 border px-2 py-4 transition-all duration-500">
					<h1 className="items-center text-center">Time Sheet</h1>
					<form
						className="flex flex-col gap-4"
						onSubmit={handleLogin}
					>
						<label htmlFor="email">Email:</label>
						<input
							className="block w-full mt-1 text-black"
							id="email"
							type="email"
							name="email"
							placeholder="Email"
							value={email}
							onChange={e => setEmail(e.target.value)}
							required
						/>
						<label htmlFor="password">Password:</label>
						<input
							className="block w-full mt-1 text-black"
							id="password"
							type="password"
							name="password"
							placeholder="Password"
							value={password}
							onChange={e => setPassword(e.target.value)}
							required
						/>
						<button
							className="bg-gray-300 border border-gray-400 p-2 hover:bg-indigo-500 hover:text-gray-300"
							type="submit"
						>
							Login
						</button>
						<Link
							to="/forgot-password"
							replace
							className="text-center font-semibold hover:text-indigo-500"
						>
							Esqueçeu a sua password?
						</Link>
					</form>
				</div>
			</div>
		</div>
	)
}

export default Login
